import { inject, InjectionToken } from '@angular/core';
import { I18nService } from 'i18n';
import { ConferenceMedia, Media } from 'media';
import { HasId, HasType, User } from 'shared';

export interface CalendarEvent extends HasId, HasType {
	readonly id: string;
	type: string;
	name: string;
	description?: string;
	timeCreated?: number;
	timeUpdated?: number;
	timeFrom: number;
	timeTo: number;
	timezoneId?: string;
	location?: string;
	joinLink?: string;
	color?: string;
	media?: Media;
	frequency?: string;
	author?: User;
	language: string;
	tags?: string[];
	properties?: {
		[key: string]: any;
	};
}

export const NULL_CALENDAR_EVENT = new InjectionToken<CalendarEvent>(
	'NULL_CALENDAR_EVENT',
	{
		providedIn: 'root',
		factory: () => {
			const i18nService = inject(I18nService);
			return new NullCalendarEvent(i18nService.getLanguage())
		}
	}
);

export class NullCalendarEvent implements CalendarEvent {
	public id: string;
	public type: string;
	public name: string;
	public info: string;
	public timeFrom: number;
	public timeTo: number;

	constructor(public language: string) {
		this.id = '';
		this.type = '';
		this.name = '';
		this.info = '';
		this.timeFrom = this.timeTo = new Date().getTime();
	}
}

export interface Conference extends CalendarEvent {
	media?: ConferenceMedia;
	properties: {
		source: string; // db or filesystem
		hostId: number;
		room_name: string,
		password: string;
		moderators: string[];
		max_participants: number;
		lobby_bypass: boolean;
	}
}

export namespace CalendarEvent {
	export function isConference(event: CalendarEvent): event is Conference {
		return (
			event.type === 'hybrid' || event.type === 'online' //&& event.media?.type === 'conference'
		);
	}
}

